import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import * as Sentry from "@sentry/react";
import { registerSW } from "virtual:pwa-register";
import { getEnvVariables } from "./constants/getEnvVariables";
import { filtrarEventoSentry } from "./lib/sentryFiltro";

const { APP_ENV } = getEnvVariables();

// Registrar service worker — se actualiza automáticamente en background
registerSW({ immediate: true });

Sentry.init({
  dsn: "https://1edbe20583d178cbb0399af76c21a679@o1255763.ingest.us.sentry.io/4509238290808832",
  enabled: import.meta.env.PROD,
  // VITE_APP_ENV ("development"/"testing"/"production" según el .env usado en
  // el build) para distinguir QA de producción real en el dashboard de Sentry
  // — enabled ya es true para cualquier `vite build`, sin este tag ambos
  // ambientes se mezclaban bajo el mismo "production" por defecto.
  environment: APP_ENV,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    // maskAllText/blockAllMedia quedan en su default (true) a propósito: hay
    // datos de pago en pantalla (RUT, tarjetas, emails) y no queremos que la
    // grabación exponga texto real ni inputs, solo la estructura de la UI.
    Sentry.replayIntegration(),
  ],
  // % de sesiones normales grabadas vs. % de sesiones con al menos un error
  // — priorizamos ver siempre lo que pasó justo antes de un error real.
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Descarta lo que no es un fallo de esta aplicación (navegador sin conexión,
  // extensiones del usuario) y agrupa los fetch caídos en una sola issue. La
  // decisión vive en src/lib/sentryFiltro.js, módulo puro y testeable; acá
  // sólo se le inyecta el estado de conexión. Ver ADR-0010.
  beforeSend: (event) =>
    filtrarEventoSentry(event, {
      online: typeof navigator === "undefined" ? undefined : navigator.onLine,
    }),
});

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
